import React from 'react';
import './style.scss';
import Lottie from 'lottie-react';
import H3Text from '@Uilib/h3Text';
import OCR from '../../../../media/lotties/ocrScanning.json';

const OCRLoader = () => (
  <div>
    <div className="ocr-loader">
    </div>
    <div className="ocr-loader__animation-wrapper">
      <Lottie
          animationData={OCR}
          loop
          className="ocr-loader__animation"
        />
        <H3Text text="Please wait while the document is being scanned.." className="ocr-loader__text" />
    </div>
  </div>
);

export default OCRLoader;
